import { createSlice } from '@reduxjs/toolkit';

function crear(state, action) {
    /* state.data= action.payload;
    state.conexion=false;
    state.error= false; */
}

function actualizar(state, action) {
    console.log(action.payload)

    state.idFlujoSelecionado = action.payload.idFlujoSelecionado ? action.payload.idFlujoSelecionado : null;
    localStorage.setItem('idFlujoSelecionado', action.payload.idFlujoSelecionado ? action.payload.idFlujoSelecionado : '')

    state.nombreFlujoSelecionado = action.payload.nombreFlujoSelecionado ? action.payload.nombreFlujoSelecionado : null;
    localStorage.setItem('nombreFlujoSelecionado', action.payload.nombreFlujoSelecionado ? action.payload.nombreFlujoSelecionado : '')
}

function destruir(state, action) {
    /* state.error= action.payload.error; */
}

/**
 * Conexión
 */
const initState = JSON.stringify(localStorage);
const storageBrowserReducer = createSlice({
    name: 'storageBrowser',
    initialState: JSON.parse(initState),
    reducers: {
        crear,
        actualizar,
        destruir,
    },
});

export const storageBrowserActions = {
    ...storageBrowserReducer.actions,
};

export default storageBrowserReducer.reducer;
